<template>
  <div class="product__details details">
    <div class="details__wrap" v-if="quantityInStores > 0 || inStock || computedOtherCityBalance">
      <header class="details__header" @click="toggleListHidden('delivery')">
        <h2 class="details__title">
          {{ $t('delivery.title') }}
        </h2>
        <button class="details__toggle-btn" :class="{ 'details__toggle-btn--rotate': !hiddenLists.delivery }"></button>
      </header>
      <ul class="details__list details__list--delivery" :class="{ 'details__list--hidden': hiddenLists.delivery }">
        <template>
          <li class="details__list-item details__list-item--inpost" v-if="inStock">
            <div class="details__delivery-wrap">
              {{ $t('delivery_inpost_postomat') }}
              <span
                class="delivery-info__price delivery-info__price--free"
              >
                {{$t('delivery.free.price') }}
              </span>
              <!--              <div class="delivery-info__info">{{ $t('delivery_inpost_info') }}</div>-->
            </div>
          </li>
          <li class="details__list-item details__list-item--inpost" v-if="inStock">
            <div class="details__delivery-wrap">
              {{ $t('delivery_inpost') }}
              <span
                class="delivery-info__price delivery-info__price--free"
              >
                {{$t('delivery.free.price') }}
              </span>
              <!--              <div class="delivery-info__info">{{ $t('delivery_inpost_info') }}</div>-->
            </div>
          </li>
          <li class="details__list-item details__list-item--dpd" v-if="inStock">
            <div class="details__delivery-wrap">
              {{ $t('delivery_dpd_department') }}
              <span
                class="delivery-info__price delivery-info__price--free"
              >
                {{$t('delivery.free.price') }}
              </span>
            </div>
          </li>
          <li class="details__list-item details__list-item--dpd" v-if="inStock">
            <div class="details__delivery-wrap">
              {{ $t('delivery_dpd') }}
              <span
                class="delivery-info__price delivery-info__price--free"
              >
                {{$t('delivery.free.price') }}
              </span>
              <div class="delivery-info__info" v-if="$t('delivery_dpd_info')">{{ $t('delivery_dpd_info') }}</div>
            </div>
          </li>
          <li
            v-if="inStock"
            class="details__list-item details__list-item--pickup"
            :class="{ 'details__list-item--disabled': isPickupUnavailableInCity }"
          >
            <div class="details__delivery-wrap">
              {{ $t('delivery_pickup_salon') }}
              <span
                v-if="!isPickupUnavailableInCity"
                class="delivery-info__price delivery-info__price--free"
              >
                {{$t('delivery.free.price') }}
              </span>
              <span v-else class="delivery-info__price delivery-info__price--unavailable">
                {{ $t('delivery_pickup_salon_unavailable') }}
              </span>
            </div>
          </li>
          <li v-if="quantityInStores > 0 || computedOtherCityBalance">
            <div class="details__list-item details__list-item--dm">
              <div class="details__delivery-wrap">
                {{ $t('pickup_title') }}
                <span
                  class="delivery-info__price delivery-info__price--free"
                >
                {{$t('delivery.free.price') }}
              </span>
              </div>
            </div>
            <div @click="openLocationModal()" class="available-cities-info" v-if="computedOtherCityBalance">
              {{ computedOtherCityBalance }}
            </div>
          </li>
        </template>
      </ul>
      <InfoButton
        class="details__info-btn"
        tooltip-horizontal-align="right"
        tooltip-is-arrow
        tooltip-is-arrow-right
        :is-error="isPickupUnavailableInCity"
        :max-tooltip-width="isPickupUnavailableInCity ? '280px' : 'auto'"
        :tooltip-text="pickupTooltipText"
      />
    </div>
    <div class="details__wrap">
      <header class="details__header" @click="toggleListHidden('services')">
        <h2 class="details__title">{{ $t('warranty.title') }}</h2>
        <button class="details__toggle-btn" :class="{ 'details__toggle-btn--rotate': !hiddenLists.services }"></button>
      </header>
      <ul
        v-if="$t('warranty.14.days') || $t('refund.60.days')"
        class="details__list details__list--services"
        :class="{ 'details__list--hidden': hiddenLists.services }"
      >
        <template>
          <li class="details__list-item" v-for="(product, i) in warranty" :key="i">
            <span class="details__list-item-text">{{
              warranty.length > 1 ? product.name[language] + ':' + ' ' : ''
            }}</span>
            {{ product.warranty }}
          </li>
        </template>
        <li class="details__list-item">
          {{ $t('refund_14_days') }}
        </li>
      </ul>
      <InfoButton
        class="details__info-btn"
        tooltip-horizontal-align="right"
        tooltip-is-arrow
        tooltip-is-arrow-right
        :tooltip-text="$t('tooltip.service')"
      />
    </div>
    <div class="details__wrap">
      <header class="details__header" @click="toggleListHidden('payment')">
        <h2 class="details__title">{{ $t('payment.title') }}</h2>
        <button class="details__toggle-btn" :class="{ 'details__toggle-btn--rotate': !hiddenLists.payment }"></button>
      </header>
      <ul class="details__list details__list--payment" :class="{ 'details__list--hidden': hiddenLists.payment }">
        <li class="details__list-item">
          {{ $t('payment_on_received_dpd') }}
        </li>
        <li class="details__list-item">
          {{ $t('payment_safe_online') }}
        </li>
        <li class="details__list-item">
          {{ $t('payment_to_account') }}
        </li>
        <li class="details__list-item">
          {{ $t('payment_in_store') }}
          <ul class="payment__list payment__list--mt">
            <li class="payment__list-item">
              <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIwLjc3OSAxNC45aC0zLjg4NEwxOS4zMjUuMjY0aDMuODgzTDIwLjc4IDE0Ljl6TTM0Ljg2MS42MjNBOS43OTcgOS43OTcgMCAwIDAgMzEuMzc3IDBjLTMuODM2IDAtNi41MzcgMS45OTMtNi41NTQgNC44NDEtLjAzMiAyLjEwMiAxLjkzNCAzLjI3IDMuNDA1IDMuOTcgMS41MDMuNzE3IDIuMDEzIDEuMTg0IDIuMDEzIDEuODIyLS4wMTUuOTgtMS4yMTQgMS40MzMtMi4zMzIgMS40MzMtMS41NTEgMC0yLjM4Mi0uMjMzLTMuNjQ1LS43NzlsLS41MTEtLjIzMy0uNTQ0IDMuMjg1Yy45MTEuNDA0IDIuNTkuNzYzIDQuMzMyLjc3OCA0LjA3NiAwIDYuNzMtMS45NjEgNi43NjEtNC45OTcuMDE2LTEuNjY2LTEuMDIzLTIuOTQzLTMuMjYtMy45ODYtMS4zNi0uNjctMi4xOTEtMS4xMi0yLjE5MS0xLjgwNi4wMTYtLjYyMy43MDQtMS4yNiAyLjIzNy0xLjI2YTYuNzUgNi43NSAwIDAgMSAyLjg5NC41NmwuMzUxLjE1NS41MjgtMy4xNnpNNDAuMDI0IDkuNzE1Yy4zMi0uODQgMS41NS00LjA5NCAxLjU1LTQuMDk0LS4wMTYuMDMuMzItLjg1Ny41MTItMS40MDJsLjI3MSAxLjI2MXMuNzM2IDMuNTAzLjg5NSA0LjIzNWgtMy4yMjh6bTQuNzk0LTkuNDVoLTMuMDA0Yy0uOTI3IDAtMS42My4yNjUtMi4wMyAxLjIxNGwtNS43NyAxMy40Mmg0LjA3NWwuODE2LTIuMTk1aDQuOTg3Yy4xMTIuNTE0LjQ2NCAyLjE5NS40NjQgMi4xOTVoMy41OTZMNDQuODIuMjY1ek0xMy42NDYuMjY1bC0zLjgwNCA5Ljk4LS40MTYtMi4wMjVjLS43MDMtMi4zMzUtMi45MDktNC44NzItNS4zNy02LjEzNEw3LjU0IDE0Ljg4NGg0LjEwOEwxNy43NTQuMjY1aC00LjEwOHoiIGZpbGw9IiM5MDkwOTAiLz48cGF0aCBkPSJNNi4zMTQuMjY1SC4wNjRMMCAuNTYxYzQuODc1IDEuMjE0IDguMTA0IDQuMTQyIDkuNDMgNy42Nkw4LjA3MiAxLjQ5NUM3Ljg0OC41NjEgNy4xNi4yOTYgNi4zMTQuMjY1eiIgZmlsbD0iI0Q1RDVENSIvPjwvc3ZnPg==" alt="visa" />
            </li>
            <li class="payment__list-item">
              <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE1LjcxNyAxLjYxN2gtNi42VjEzLjVoNi42VjEuNjE3eiIgZmlsbD0iI0FFQUVBRSIvPjxwYXRoIGQ9Ik05LjUzNSA3LjU1OWE3LjU4NCA3LjU4NCAwIDAgMSAyLjg3MS01Ljk0MkE3LjQ0NSA3LjQ0NSAwIDAgMCA3Ljc1NCAwQzMuNTg0IDAgLjIxIDMuMzguMjEgNy41NTljMCA0LjE3OCAzLjM3NCA3LjU1OCA3LjU0NCA3LjU1OCAxLjc2IDAgMy4zNzQtLjYwOCA0LjY1Mi0xLjYxNmE3LjU4NCA3LjU4NCAwIDAgMS0yLjg3LTUuOTQyeiIgZmlsbD0iIzkwOTA5MCIvPjxwYXRoIGQ9Ik0yNC42MjQgNy41NTljMCA0LjE3OC0zLjM3NCA3LjU1OC03LjU0NCA3LjU1OGE3LjQ5IDcuNDkgMCAwIDEtNC42NTItMS42MTYgNy41MjEgNy41MjEgMCAwIDAgMi44Ny01Ljk0MiA3LjU4NCA3LjU4NCAwIDAgMC0yLjg3LTUuOTQyQTcuNDkgNy40OSAwIDAgMSAxNy4wOCAwYzQuMTcgMCA3LjU0NCAzLjM4IDcuNTQ0IDcuNTU5eiIgZmlsbD0iI0Q1RDVENSIvPjwvc3ZnPg==" alt="mastercard" />
            </li>
            <li class="payment__list-item">
              <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNDUgMTIzIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTEzIDUuNzVIOTIuMjVWMTIySDExM1Y1Ljc1WiIgZmlsbD0iIzkwOTA5MCIvPgo8cGF0aCBkPSJNMTUxLjUgNDVIMTMwLjc1VjEyMkgxNTEuNVY0NVoiIGZpbGw9IiM5MDkwOTAiLz4KPHBhdGggZD0iTTI0NC41IDEyMkwyMTMuMzIgODEuMjVMMjQyIDQ1SDIxNy41TDE5MCA4MC4xN1Y1Ljc1SDE2OS4yNVYxMjJIMTkwVjgyLjQ3TDIxNy41IDEyMkgyNDQuNVoiIGZpbGw9IiM5MDkwOTAiLz4KPHBhdGggZD0iTTM5LjM4IDQ0LjEzQzMyLjg3NzcgNDQuMTE4NyAyNi40NzUgNDUuNzI3MSAyMC43NSA0OC44MVY1Ljc1SDEuMjcwMjdlLTA2VjgzLjVDLTAuMDAxOTc2NjUgOTEuMjg5MSAyLjMwNTk0IDk4LjkwMzggNi42MzE4NyAxMDUuMzgxQzEwLjk1NzggMTExLjg1OCAxNy4xMDc0IDExNi45MDcgMjQuMzAzIDExOS44ODlDMzEuNDk4NiAxMjIuODcyIDM5LjQxNjkgMTIzLjY1MyA0Ny4wNTY1IDEyMi4xMzVDNTQuNjk2MiAxMjAuNjE2IDYxLjcxMzkgMTE2Ljg2NiA2Ny4yMjIzIDExMS4zNTlDNzIuNzMwNyAxMDUuODUyIDc2LjQ4MjMgOTguODM1NiA3OC4wMDI2IDkxLjE5NjNDNzkuNTIyOSA4My41NTcxIDc4Ljc0MzYgNzUuNjM4NiA3NS43NjMzIDY4LjQ0MjJDNzIuNzgzIDYxLjI0NTkgNjcuNzM1NiA1NS4wOTUgNjEuMjU5NCA1MC43Njc0QzU0Ljc4MzIgNDYuNDM5OCA0Ny4xNjkxIDQ0LjEzIDM5LjM4IDQ0LjEzWk0zOS4zOCAxMDIuMTNDMzUuNjk0OSAxMDIuMTMyIDMyLjA5MiAxMDEuMDQxIDI5LjAyNyA5OC45OTUxQzI1Ljk2MiA5Ni45NDkzIDIzLjU3MjYgOTQuMDQwMyAyMi4xNjEgOTAuNjM2M0MyMC43NDk0IDg3LjIzMjMgMjAuMzc5IDgzLjQ4NjEgMjEuMDk2OCA3OS44NzE2QzIxLjgxNDUgNzYuMjU3MSAyMy41ODggNzIuOTM2NiAyNi4xOTMxIDcwLjMzMDFDMjguNzk4MSA2Ny43MjM3IDMyLjExNzYgNjUuOTQ4NCAzNS43MzE4IDY1LjIyODdDMzkuMzQ1OSA2NC41MDkxIDQzLjA5MjMgNjQuODc3NCA0Ni40OTcxIDY2LjI4NzJDNDkuOTAxOCA2Ny42OTY5IDUyLjgxMiA3MC4wODQ4IDU0Ljg1OTYgNzMuMTQ4N0M1Ni45MDcxIDc2LjIxMjYgNTggNzkuODE0OSA1OCA4My41QzU4IDg4LjQzOTMgNTYuMDM4NiA5My4xNzYzIDUyLjU0NjkgOTYuNjY5OUM0OS4wNTUzIDEwMC4xNjMgNDQuMzE5MiAxMDIuMTI3IDM5LjM4IDEwMi4xM1oiIGZpbGw9IiM5MDkwOTAiLz4KPHBhdGggZD0iTTU5LjYzIDM3QzY5Ljg0NzMgMzcgNzguMTMgMjguNzE3MyA3OC4xMyAxOC41Qzc4LjEzIDguMjgyNzMgNjkuODQ3MyAwIDU5LjYzIDBDNDkuNDEyNyAwIDQxLjEzIDguMjgyNzMgNDEuMTMgMTguNUM0MS4xMyAyOC43MTczIDQ5LjQxMjcgMzcgNTkuNjMgMzdaIiBmaWxsPSIjRDVENUQ1Ii8+Cjwvc3ZnPgo=" alt="blik" />
            </li>
            <li class="payment__list-item">
              <img src="data:image/svg+xml;base64,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" alt="apple-pay" />
            </li>
            <li class="payment__list-item">
              <img src="data:image/svg+xml;base64,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" alt="google-pay" />
            </li>
          </ul>
        </li>
      </ul>
      <InfoButton
        class="details__info-btn"
        tooltip-horizontal-align="right"
        tooltip-is-arrow
        tooltip-is-arrow-right
        :tooltip-text="$t('tooltip.payment')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import dateTimeHelper from '@/helpers/dateTimeHelpers'
import { isTouch } from '../../../mixins/isTouchDevice'
import { formattedDeliveryInfo } from '../../../mixins'
import InfoButton from '../../helpers/InfoButton'
import { COURIER_PRICE_LIMIT, NOVA_POSHTA_PRICE_LIMIT, UKR_POSHTA_PRICE_LIMIT } from '@/constants'

export default {
  name: 'ProductDetails',
  mixins: [isTouch, formattedDeliveryInfo],
  data () {
    return {
      isLoadingAvailability: false,
      hiddenLists: {
        delivery: false,
        services: true,
        payment: true
      }
    }
  },
  components: {
    InfoButton
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      otherCityBalance: state => state.productInfo.productInfo.otherCityBalance,
      isOnlyOnSite: state => state.productInfo.productInfo.isOnlyOnSite,
      availableInStore: state => state.productInfo.productInfo.availableInStore,
      inStock: state => state.productInfo.productInfo.inStock,
      storesData: state => state.productInfo.productInfo.storesData,
      isArchive: state => state.productInfo.productInfo.isArchive,
      isNovelty: state => state.productInfo.productInfo.isNovelty,
      price: state => state.productInfo.productInfo.price,
      productId: state => state.productInfo.productInfo.productId,
      warranty: state => state.productInfo.warranty,
      maxSideLength: state => state.productInfo.productInfo.maxSideLength,
      language: state => state.translation.language,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      managerStoreUid: state => state.checkout.managerStoreUid,
      currLocale: state => state.translation.language,
      userStore: state => state.geoLocation.userStore,
      storesInCity: state => state.geoLocation.storesInCity
    }),
    // Есть ли остатки товара хотя бы в одном магазине выбранного города
    hasQuantityInCityStores () {
      return (this.storesInCity || []).some(store => {
        const storeData = (this.storesData || []).find(el => +el.id === +store.id)
        return storeData && +storeData.quantity > 0
      })
    },
    // Товар в наличии, но в выбранном городе нет магазинов или в них нет остатков - самовывоз из салона показываем недоступным
    isPickupUnavailableInCity () {
      return !!this.inStock && !this.hasQuantityInCityStores
    },
    // Текст тултипа доставки: отдельный для случаев "нет магазинов в городе" и "нет остатков в магазинах города"
    pickupTooltipText () {
      if (!this.isPickupUnavailableInCity) {
        return this.$t('tooltip.delivery')
      }
      return this.storesInCity && this.storesInCity.length
        ? this.$t('tooltip.delivery_pickup_salon_no_balance')
        : this.$t('tooltip.delivery_pickup_salon_unavailable')
    },
    computedOtherCityBalance () {
      if (this.otherCityBalance && this.otherCityBalance.length > 0) {
        return this.$t('delivery-store-balance.available-cities-info', { cities: this.otherCityBalance.join(', ') })
      }
      return ''
    },
    quantityInStores () {
      if (this.userStore && this.userStore.id) {
        const store = this.storesData.find(el => +el.id === +this.userStore.id)
        return store ? +store.quantity : 0
      }
      return 0
    },
    isFreeDeliveryCourierDm () {
      return +this.price >= COURIER_PRICE_LIMIT
    },
    isFreeDeliveryUp () {
      return +this.price >= UKR_POSHTA_PRICE_LIMIT
    },
    isFreeDeliveryNp () {
      return +this.price > NOVA_POSHTA_PRICE_LIMIT
    },
    cityName () {
      if (this.selectedUserLocation) {
        return this.selectedUserLocation.name
      } else {
        return this.$t('city')
      }
    },
    titleForExpressDelivery () {
      return dateTimeHelper.isAvailableTodayExpressDelivery() ? this.$t('delivery.company.quick.courier.before') : this.$t('delivery.company.quick.courier.after')
    }
  },
  methods: {
    ...mapActions(['FETCH_PRODUCT_AVAILABILITY_IN_SHOPS']),
    toggleListHidden (list) {
      this.hiddenLists[list] = !this.hiddenLists[list]
    },
    openLocationModal () {
      this.$modal.show('city-location-modal')
    },
    checkAvailability () {
      if (this.isLoadingAvailability) return

      if (this.productId && this.selectedUserLocation && this.selectedUserLocation.city_id) {
        this.isLoadingAvailability = true

        this.FETCH_PRODUCT_AVAILABILITY_IN_SHOPS({
          productId: this.productId,
          cityId: this.selectedUserLocation.city_id
        })
          .then(res => {
            if (res.data) {
              this.$modal.show('map-modal', {
                spots: this.formatDeliverySpotsInfo(res.data.stores, 'availability'),
                mailName: 'pickup',
                preSelectedSpot: this.managerStoreUid
              })
            }
          })
          // eslint-disable-next-line no-return-assign
          .finally(() => (this.isLoadingAvailability = false))
      }
    }
  }
}
</script>

<style scoped lang="sass">
.available-cities-info
  padding: 4px 12px
  background-color: #FFFAE9
  border-radius: 3px
  border: 1px solid #FFC700
  font-size: 14px
  line-height: 21px
  color: #000
  cursor: pointer

.details__wrap
  position: relative
  border-bottom: 1px solid $nd-border-color

  +mmax(768)
    overflow: hidden

  &:first-child
    border-top: 1px solid $nd-border-color

    +mmin($tablet)
      border-top: none

.details__header
  display: flex
  justify-content: space-between
  align-items: center
  padding: 20px 0

  +mmax(768)
    cursor: pointer

.details__title
  position: relative
  font-size: 16px
  font-weight: 500
  margin: 0
  padding: 0

.details__select-city
  position: relative
  color: $nd-link-color
  border-bottom: 1px solid $nd-link-color
  cursor: pointer

  &:after
    position: absolute
    right: -15px
    top: 50%
    transform: translateY(-50%)
    content: ''
    display: block
    width: 11px
    height: 6px
    background: url('/img/svgo/link-arrow.svg')

.details__list
  +list-unstyled
  height: 100%
  max-height: 400px
  transition: ease-in-out .4s
  margin: 0 0 20px
  list-style: disc
  list-style-position: inside

  &--hidden
    +mmax(768)
      margin: 0
      max-height: 0

.payment__list
  +list-unstyled
  &--mt
    margin-top: 22px

.details__list--services
  .details__list-item-text
    color: $placeholder-color

.details__list-item
  font-size: 14px

  &:not(:last-child)
    margin-bottom: 15px

.payment
  display: flex

.payment__list
  display: flex
  flex-flow: row wrap

.payment__list-item
  display: block

  &:not(:last-child)
    margin: 0 10px 0 0

.details__list--delivery
  list-style: none
  .details__list-item
    display: flex

  .details__check-availability-btn
    max-width: max-content
    font-size: 14px
    padding: 0
    background: none
    border: none
    border-bottom: 1px solid #3e77aa
    color: $nd-link-color
    margin-top: 10px

    &:hover
      border-color: transparent

    +mmin($small)
      margin-top: 0

  .details__delivery-wrap
    width: 100%
    display: flex
    flex-flow: column

    +mmin($small)
      justify-content: space-between
      flex-flow: row wrap

  .details__delivery-info
    display: flex
    flex-flow: column

    +mmin($small)
      align-items: center
      flex-flow: row wrap

  .delivery-info__info
    margin-top: 6px
    font-size: 10px
    width: 100%
    padding-right: 50%
    +mmax($tablet--hor)
      padding-right: 0
  .delivery-info__date
    display: none
    color: $placeholder-color

  .details-info__text
    margin-right: 20px

  .delivery-info__price
    margin-top: 10px

    +mmin($small)
      margin-top: 0

  .delivery-info__price--free
    color: #359D3F

  .delivery-info__price--unavailable
    color: $nd-error-text-color

  .details__list-item--disabled
    color: $nd-label-color

    &:before
      opacity: .5

  .details__list-item--dpd
    &:before
      content: ''
      width: 48px
      height: 20px
      background-image: url(/img/svgo/product-page/dpd_list_icon.svg)
      background-size: contain
      background-position: center
      background-repeat: no-repeat
      padding: 0
      margin-right: 10px
  .details__list-item--inpost
    &:before
      content: ''
      width: 48px
      height: 25px
      background-image: url(/img/svgo/product-page/inpost.svg)
      background-size: contain
      background-position: left center
      background-repeat: no-repeat
      padding: 0
      margin: -3px 10px -2px 0

  .details__list-item--pickup
    &:before
      content: ''
      width: 48px
      height: 20px
      background-image: url(/img/svgo/product-page/logo-dm.svg)
      background-size: contain
      background-position: left center
      background-repeat: no-repeat
      padding: 0
      margin-right: 10px

  .details__list-item--dm
    width: 100%
    &:before
      content: ''
      width: 48px
      height: 20px
      background-image: url(/img/svgo/product-page/pickup-dm.svg)
      background-size: contain
      background-position: center
      background-repeat: no-repeat
      padding: 0
      margin-right: 10px

  .details__list-item--np
    &:before
      content: url(/img/svgo/product-page/np_list_icon.svg)
      padding-right: 13px

  .details__list-item--up
    &:before
      content: url(/img/svgo/product-page/up_list_icon.svg)
      padding-right: 16px

  .details__list-item--quick
    &:before
      content: url(/img/svgo/product-page/quick_list_icon.svg)
      padding-right: 10px

.details__info-btn
  display: none
  position: absolute
  right: 0
  top: 20px

  +mmin($tablet)
    display: block
.details__toggle-btn
  width: 12px
  height: 6px
  display: none
  border: 0
  background-color: transparent
  background-image: url('/img/svgo/product-page/details-arrow.svg')
  background-position: center
  background-repeat: no-repeat
  transition: ease-in-out .4s

  +mmax(768)
    display: block

  &--rotate
    transform: rotate(180deg)

.details__check-availability
  margin: 0 0 40px 0

.check-availability
  background: #F8F8F8
  border-radius: 3px
  padding: 15px 25px
  display: flex
  justify-content: space-between
  align-items: center
  flex-wrap: wrap

  +mmax(601)
    padding: 15px

  &__info
    position: relative
    margin: 8px 0
    padding-left: 50px

    +mmax(601)
      padding-left: 40px

    &:before
      content: url('/img/svgo/product-page/box.svg')
      position: absolute
      left: 0
      top: -5px
  &__text
    font-size: 14px
    color: #333
    &+&
      margin-top: 10px
    &--success
      color: #359D3F
  &__btn
    margin: 8px 0
    margin-left: 50px
    font-size: 14px

    +mmax(601)
      margin-left: 40px
</style>
